export default {
  meta: {
    title: '规划管理',
  },
};
